var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _setup.isEmptySlotList
      ? _c(
          "div",
          [
            _setup.isExpressAppointment
              ? [
                  _setup.isMobile
                    ? _c(_setup.AppointmentButtonCallLpu, {
                        attrs: {
                          phone: _setup.lpuPhoneValue,
                          "lpu-working-text": _vm.lpuWorkingText,
                        },
                      })
                    : _vm._e(),
                ]
              : _c(_setup.CalendarStub),
          ],
          2
        )
      : _c(
          "div",
          { staticClass: "appointment-calendar" },
          [
            _c(_setup.SliderGroup, {
              attrs: {
                items: _setup.dayItems,
                "active-index": _setup.activeIndex,
                "padding-x": _vm.paddingX,
                "padding-left": _vm.paddingLeft,
                "padding-right": _vm.paddingRight,
                fog: _vm.fog,
                "scroll-to-active": !!_vm.initDay,
              },
              on: {
                "slider-group:click-item": function ($event) {
                  return _setup.handleClickItem($event)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ item, index }) {
                    return [
                      _c(_setup.SelectableTab, {
                        attrs: {
                          title: _setup.t(item.title, _setup.options),
                          subtitle: _setup.t(item.subtitle, _setup.options),
                          label: _setup.t(item.label, _setup.options),
                          active: index === _setup.activeIndex,
                          disabled: item.disabled,
                          small: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            (item.subtitle === "Сб" ||
                              item.subtitle === "Вс") &&
                            !item.disabled &&
                            index !== _setup.activeIndex
                              ? {
                                  key: "subtitle",
                                  fn: function () {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "text-error--text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _setup.t(
                                                item.subtitle,
                                                _setup.options
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mt-4",
                style: {
                  "padding-left": `${_vm.paddingLeft ?? _vm.paddingX}px`,
                  "padding-right": `${_vm.paddingRight ?? _vm.paddingX}px`,
                },
              },
              [
                _c(_setup.AppointmentCalendarSlotButtons, {
                  attrs: {
                    "is-disabled": _setup.isExpressAppointment,
                    "doctor-id": _vm.doctorId,
                    "current-day-slots": _vm.slots[_setup.activeDayItemDate],
                    "selected-slot": _setup.selectedSlot,
                    "is-current-day-selected":
                      _setup.selectedDay === _setup.activeDayItemDate,
                  },
                  on: { "slot-buttons:click": _setup.handleClickOnTime },
                }),
                _vm._v(" "),
                _setup.isExpressAppointment
                  ? [
                      _setup.isMobile
                        ? _c(_setup.AppointmentButtonCallLpu, {
                            staticClass: "mt-4",
                            attrs: {
                              phone: _setup.lpuPhoneValue,
                              "lpu-working-text": _vm.lpuWorkingText,
                            },
                          })
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }